<app-shared-loading *ngIf="loading"></app-shared-loading>
<div class="general-title">
  <h1 class="pl-1 title">
    {{ 'payMethods-Title-Desktop' | translation | async }}
  </h1>
  <p class="pl-1">
    {{ 'payMethods-Subtitle-Desktop' | translation | async }}
    <a [href]="checkoutGuideDocLink" target="blank"> {{ 'payMethods-Subtitle-Manual' | translation | async }}</a>
  </p>
</div>
<div class="general-title-mobile">
  <h1 class="pl-1 title">
    {{ 'payMethods-Title-Mobile' | translation | async }}
  </h1>
  <p class="pl-1">
    {{ 'payMethods-Subtitle-Desktop' | translation | async }}
    <a [href]="checkoutGuideDocLink" target="blank"> {{ 'payMethods-Subtitle-Manual' | translation | async }}</a>
  </p>
</div>

<div class="blockCard">
  <div class="row" id="TransferenciaBancaria" *ngIf="!(transfers.length == 0) && !isCreditCardUnique">
    <h3 class="col-3 center">{{ 'payMethods-TB' | translation | async }}</h3>
    <section class="col-7">
      <div *ngFor="let transfer of transfers" (click)="methods(transfer)">
        <img src="{{ transfer.logo }}" [alt]="transfer.name" />
      </div>
    </section>
  </div>

  <div class="row" id="bnpl" *ngIf="!(bnplMethods.length == 0) && !isCreditCardUnique">
    <h3 class="col-3 center">
      {{ 'payMethods-Bnpl' | translation | async }}
    </h3>
    <section class="col-7">
      <div *ngFor="let bnpl of bnplMethods" (click)="methods(bnpl)">
        <img [src]="bnpl.logo" [alt]="bnpl.name" />
      </div>
    </section>
  </div>

  <div class="row" id="wallet" *ngIf="!(wallets.length == 0) && !isCreditCardUnique">
    <h3 class="col-3 center">
      {{ 'payMethods-Wallet' | translation | async }}
    </h3>
    <section class="col-7">
      <div *ngFor="let wallet of wallets" (click)="methods(wallet)">
        <img [src]="wallet.logo" [alt]="wallet.name" />
      </div>
    </section>
  </div>

  <div class="row" id="bancolombia" *ngIf="bancolombiaMethods.length !== 0 && !isCreditCardUnique">
    <h3 class="col-3 center">{{ 'payMethods-Bancolombia' | translation | async }}</h3>
    <section class="col-7">
      <div *ngFor="let payment of bancolombiaMethods" (click)="methodsByTemplete(payment)">
        <img class="deposits __method_brands" [src]="payment.logo" [alt]="payment.name" />
      </div>
    </section>
  </div>

  <div class="row" id="efectivo" *ngIf="!(networks.length == 0) && !isCreditCardUnique">
    <ng-container *ngIf="showNewCRMessageCash; else inactive">
      <h3 class="col-3 center">{{ 'payMethods-Cash-Correspondents' | translation | async }}</h3>
    </ng-container>
    <ng-template #inactive>
      <h3 class="col-3 center">{{ 'payMethods-Cash' | translation | async }}</h3>
    </ng-template>
    <section class="col-7">
      <div *ngFor="let net of networks" (click)="methods(net)">
        <img [src]="net.logo" [alt]="net.name" />
      </div>
    </section>
  </div>

  <div class="row" id="TarjetasDeCredito" *ngIf="!(creditCards.length == 0)">
    <h3 class="col-3 center">{{ 'payMethods-TC' | translation | async }}</h3>
    <section class="col-7" *ngIf="!enableCheckoutEmbebedTcFormFF">
      <div *ngFor="let creditCard of creditCards" (click)="methods(creditCard)">
        <img class="creditCardBrand" [src]="creditCard.logo" [alt]="creditCard.name" />
      </div>
    </section>
    <section class="col-7" *ngIf="enableCheckoutEmbebedTcFormFF">
      <div (click)="methods({ category: '4', franchise: getFranchises(), logo: getTcLogo() })">
        <img class="creditCardBrand" [src]="getTcLogo() | safe" alt="Credit Cards" />
      </div>
    </section>
  </div>

  <div class="row" id="deposito" *ngIf="!(deposits.length == 0) && !isCreditCardUnique">
    <h3 class="col-3 center">{{ 'payMethods-DB' | translation | async }}</h3>
    <section class="col-7">
      <div *ngFor="let deposit of deposits" (click)="methods(deposit)">
        <img [src]="deposit.logo" class="deposits __method_brands" [alt]="deposit.name" />
      </div>
    </section>
  </div>

  <div class="row" id="transferCRC" *ngIf="!(transfersCRC.length == 0) && !isCreditCardUnique">
    <h3 class="col-3 center">
      {{ 'payMethods-transferCRC' | translation | async }}
    </h3>
    <section class="col-7">
      <div *ngFor="let transfer of transfersCRC" (click)="methods(transfer)">
        <img [src]="transfer.logo" class="deposits __method_brands" [alt]="transfer.name" />
      </div>
    </section>
  </div>

  <div class="row" id="subMenuCR" *ngIf="(subMenuBNCR.length >= 1 || subMenuBCR.length >= 1 || subMenuLafise.length >= 1) && !isCreditCardUnique">
    <h3 class="col-3 center">
      {{ 'from-banks' | translation | async }}
    </h3>
    <section class="col-7">
      <div *ngIf="subMenuBNCR.length >= 1" (click)="subMenu(subMenuBNCR)">
        <img [src]="logoBNCR" class="deposits __method_brands" alt="Banco Nacional Costa Rica" />
      </div>
      <div *ngIf="subMenuBCR.length >= 1" (click)="subMenu(subMenuBCR)">
        <img [src]="logoBCR" class="deposits __method_brands" alt="Banco Costa Rica" />
      </div>
      <div *ngIf="subMenuLafise.length >= 1 && lafiseBanksPaymentMethodFF" (click)="subMenu(subMenuLafise)">
        <img [src]="logoLafise" class="deposits __method_brands" alt="Banco Lafise" />
      </div>
    </section>
  </div>

  <div class="row" *ngIf="splitMethods.length > 0 && !isCreditCardUnique">
    <h3 class="col-3 center">
      {{ 'title-Split-Payment' | translation | async }}
    </h3>
    <section class="col-7">
      <div *ngFor="let split of splitMethods" (click)="methods(split)">
        <img [src]="split.logo" [alt]="split.name" />
      </div>
    </section>
  </div>

  <div class="row" *ngIf="sinpeMethodsList.length > 0 && !isCreditCardUnique">
    <h3 class="col-3 center">
      {{ 'sinpe-Movil-Title' | translation | async }}
    </h3>
    <section class="col-7">
      <div *ngFor="let sinpe of sinpeMethodsList" (click)="methods(sinpe)">
        <img [src]="sinpe.logo" [alt]="sinpe.name" />
      </div>
    </section>
  </div>

  <div class="row" id="subMenuGU" *ngIf="subMenuBAM.length >= 1">
    <h3 class="col-3 center">
      {{ 'banks' | translation | async }}
    </h3>
    <section class="col-7">
      <div *ngIf="subMenuBAM.length >= 1" (click)="subMenuGU(subMenuBAM)">
        <img [src]="logoBam" class="deposits __method_brands" alt="BAM" />
      </div>
      <div *ngIf="subMenuBI.length >= 1" (click)="subMenuGU(subMenuBI)">
        <img [src]="logoBI" class="deposits __method_brands" alt="Banco Industrial" />
      </div>
    </section>
  </div>

  <div class="row" *ngIf="ptosColFF && puntosColombiaList.length > 0 && !isCreditCardUnique">
    <h3 class="col-3 center">
      {{ 'colombia-points' | translation | async }}
    </h3>
    <section class="col-7">
      <div *ngFor="let puntosColombia of puntosColombiaList" (click)="methods(puntosColombia)">
        <img [src]="logoPuntosCol" [alt]="puntosColombia.name" />
      </div>
    </section>
  </div>

  <div class="row" *ngIf="apiPayInList && apiPayInList.length > 0 && !isCreditCardUnique">
    <h3 class="col-3 center">Buy now pay later</h3>
    <section class="col-7">
      <div *ngFor="let apiPayIn of apiPayInList" (click)="methods(apiPayIn)">
        <img [src]="apiPayIn.logo" [alt]="apiPayIn.name" />
      </div>
    </section>
  </div>
</div>
